<script>
import {
  LogShortcutBannerSolgtComItemClicked,
  LogShortcutBannerCreateAdItemClicked,
  LogShortcutBannerRequirementSearchItemClicked,
  LogShortcutBannerStartSearchItemClicked,
} from '@/events'

export default {
  template: '<template></template>',
  mounted() {
    const containers = document.getElementsByClassName(
      'shortcut-banner__option-list-item'
    )

    Array.from(containers).forEach(container => {
      this.handleSolgtComLink(container)
      this.handleCreateAdLink(container)
      this.handleRequirementSearchLink(container)
      this.handleStartSearchLink(container)
    })
  },
  methods: {
    handleSolgtComLink(container) {
      this.handleLink(container, 'js-shortcut-solgt-com-link', () => {
        LogShortcutBannerSolgtComItemClicked()
      })
    },
    handleCreateAdLink(container) {
      this.handleLink(container, 'js-shortcut-create-ad', () => {
        LogShortcutBannerCreateAdItemClicked()
      })
    },
    handleRequirementSearchLink(container) {
      this.handleLink(container, 'js-shortcut-requirement-search', () => {
        LogShortcutBannerRequirementSearchItemClicked()
      })
    },
    handleStartSearchLink(container) {
      this.handleLink(container, 'js-shortcut-start-search', () => {
        LogShortcutBannerStartSearchItemClicked()
      })
    },
    handleLink(container, className, callback, eventName = 'click') {
      const links = container.getElementsByClassName(className)

      Array.from(links).forEach(link => {
        link.addEventListener(eventName, () => {
          callback()
        })
      })
    },
  },
}
</script>
